import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DefaultStatisticsCard from "examples/Cards/StatisticsCards/DefaultStatisticsCard";
import DataTable from "examples/Tables/DataTable";

import api from "services/api";
import { requireAuth } from "actions/AuthAction";

const statusLabel = {
  DRAFT: "Draft",
  DIAJUKAN: "Diajukan",
  VERIFIKASI: "Diverifikasi",
  PERBAIKAN: "Perlu Perbaikan",
  PROSES_TEKNIS: "Proses Teknis",
  DISETUJUI: "Disetujui",
  DITOLAK: "Ditolak",
  PENANDATANGANAN: "Penandatanganan",
  SELESAI: "Selesai",
};

function DashboardPemohon() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pengajuan, setPengajuan] = useState([]);
  const [stats, setStats] = useState({
    total: 0,
    draft: 0,
    proses: 0,
    perbaikan: 0,
    selesai: 0,
  });

  useEffect(() => {
    const user = requireAuth(navigate, ["PEMOHON"]);
    if (!user) return;

    api
      .get("pengajuan")
      .then((res) => {
        const data = res.data?.data || [];
        setPengajuan(data);
        setStats({
          total: data.length,
          draft: data.filter((p) => p.status === "DRAFT").length,
          proses: data.filter((p) =>
            ["DIAJUKAN", "VERIFIKASI", "PROSES_TEKNIS", "DISETUJUI", "PENANDATANGANAN"].includes(
              p.status
            )
          ).length,
          perbaikan: data.filter((p) => p.status === "PERBAIKAN").length,
          selesai: data.filter((p) => p.status === "SELESAI").length,
        });
      })
      .catch(() => alert("Gagal memuat data pengajuan"))
      .finally(() => setLoading(false));
  }, [navigate]);

  const columns = [
    { Header: "Nomor", accessor: "nomor_pengajuan", width: "20%" },
    { Header: "Layanan", accessor: "nama_jenis_izin", width: "35%" },
    { Header: "Status", accessor: "status_label", width: "20%" },
    { Header: "Tanggal", accessor: "tanggal", width: "15%" },
    { Header: "Aksi", accessor: "action", width: "10%", align: "center" },
  ];

  const rows = pengajuan.slice(0, 10).map((p) => ({
    nomor_pengajuan: p.nomor_pengajuan,
    nama_jenis_izin: p.nama_jenis_izin,
    status_label: statusLabel[p.status] || p.status,
    tanggal: p.tanggal_pengajuan
      ? new Date(p.tanggal_pengajuan).toLocaleDateString("id-ID")
      : "-",
    action: (
      <MDButton
        variant="text"
        color="info"
        size="small"
        onClick={() => navigate(`/pengajuan/${p.id}`)}
      >
        Detail
      </MDButton>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={3}>
          <MDTypography variant="h4" fontWeight="medium">
            Dashboard Pemohon
          </MDTypography>
          <MDTypography variant="button" color="text">
            Pantau status permohonan perizinan Anda
          </MDTypography>
        </MDBox>

        <Grid container spacing={3} mb={3}>
          <Grid item xs={12} md={6} lg={2.4}>
            <DefaultStatisticsCard
              title="Total Pengajuan"
              count={loading ? "..." : stats.total}
              icon={{ color: "info", component: "assignment" }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={2.4}>
            <DefaultStatisticsCard
              title="Draft"
              count={loading ? "..." : stats.draft}
              icon={{ color: "secondary", component: "edit" }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={2.4}>
            <DefaultStatisticsCard
              title="Diproses"
              count={loading ? "..." : stats.proses}
              icon={{ color: "warning", component: "hourglass_top" }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={2.4}>
            <DefaultStatisticsCard
              title="Perbaikan"
              count={loading ? "..." : stats.perbaikan}
              icon={{ color: "error", component: "build" }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={2.4}>
            <DefaultStatisticsCard
              title="Selesai"
              count={loading ? "..." : stats.selesai}
              icon={{ color: "success", component: "check_circle" }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3} display="flex" justifyContent="space-between" alignItems="center">
                <MDTypography variant="h6">Pengajuan Terbaru</MDTypography>
                <MDBox display="flex" gap={1}>
                  <MDButton
                    variant="gradient"
                    color="info"
                    onClick={() => navigate("/layanan")}
                  >
                    <Icon sx={{ mr: 1 }}>add</Icon> Ajukan Layanan
                  </MDButton>
                  <MDButton variant="outlined" color="info" onClick={() => navigate("/pengajuan")}>
                    Lihat Semua
                  </MDButton>
                </MDBox>
              </MDBox>
              <MDBox pb={3} px={3}>
                <DataTable
                  table={{ columns, rows }}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  isSorted={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DashboardPemohon;
